// auth.api.ts
import api from '@/shared/api/api';
import { AuthResponse, LoginPayload } from '../model';

export interface ForgotPasswordPayload {
  email: string;
  redirectTo: string;
}

export interface ResetPasswordPayload {
  newPassword: string;
  token: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export const authApi = {
  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const res = await api<AuthResponse>({
      url: '/v1/auth/login-web',
      method: 'POST',
      data: payload,
    });
    return res;
  },

  logout: async (): Promise<void> => {
    await api({
      url: '/v1/auth/logout-web',
      method: 'POST',
    });
  },

  forgotPassword: async (payload: ForgotPasswordPayload): Promise<ForgotPasswordResponse> => {
    return api<ForgotPasswordResponse>({
      url: '/v1/auth/forgot-password',
      method: 'POST',
      data: payload,
    });
  },

  resetPassword: async (payload: ResetPasswordPayload): Promise<ResetPasswordResponse> => {
    return api<ResetPasswordResponse>({
      url: '/v1/auth/change-password',
      method: 'POST',
      data: payload,
    });
  },
};
